<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs3 />
      <v-flex xs6 class="font-number text-xs-center dayBorder">
        <v-card class="weekendBack elevation-0">
          <!-- PRESETS -->
          <v-card-title primary-title>
            <v-flex xs12>{{ $t("presets") }}</v-flex>
            <v-layout row wrap>
              <v-flex xs2 v-for="(scene,i) in $store.getters.getPlayerLightScenes" :key="i">
                <v-btn
                  :disabled="!$store.getters.getPlayerRoomLightsEnabled"
                  @click="setLightScene(scene)"
                  large
                  fab
                  class="icon-transform-1"
                  :style="{ 'background-color': scene}">
                  <v-icon>lightbulb_outline</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-title>
          <!-- SHOWS -->
          <v-card-title primary-title>
            <v-flex xs12>{{ $t("shows") }}</v-flex>
            <v-layout row wrap>
              <v-flex xs2 v-for="(show,i) in $store.getters.getPlayerLightShows" :key="i">
                <v-btn
                  :disabled="!$store.getters.getPlayerRoomLightsEnabled"
                  @click="setLightShow(show.color, show.value)"
                  large
                  fab
                  class="icon-transform-1"
                  :style="{ 'background-color': show.color}">
                  {{ show.name }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-title>
          <!-- INSTRUCTOR -->
          <v-card-title primary-title>
            <v-flex xs12>{{ $t("instructor") }}</v-flex>
            <v-flex xs4 />
            <v-flex xs2>
              <v-btn
                :disabled="!$store.getters.getPlayerInstructorLightEnabled"
                color="success"
                @click="instructorLight(true)"
                fab
                large
                dark>
                <v-icon>check</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs2>
              <v-btn
                :disabled="!$store.getters.getPlayerInstructorLightEnabled"
                color="error"
                @click="instructorLight(false)"
                fab
                large
                dark>
                <v-icon>clear</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs4 />
          </v-card-title>
          <!-- OFF BTN -->
          <v-card-title primary-title>
            <v-flex xs12>{{ $t("turnoff") }}</v-flex>
            <v-flex xs12>
              <v-btn
                :disabled="!$store.getters.getPlayerRoomLightsEnabled"
                @click="lightsOff()"
                color="error"
                fab
                large
                dark>
                <v-icon>clear</v-icon>
              </v-btn>
            </v-flex>
          </v-card-title>
          <v-flex xs12 />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  methods: {
    setLightScene(color) {
      this.$store.dispatch("setLightScene", color);
    },
    setLightShow(color, value) {
      this.$store.dispatch("setLightShow", { color, value });
    },
    instructorLight(lightOn) {
      this.$store.dispatch("setInstructorLight", lightOn);
    },
    lightsOff() {
      this.$store.dispatch("setLightScene", "rgba(0,0,0,0)");
    }
  }
};
</script>

<style scoped>
.weekendBack {
  min-height: 400px;
  background: linear-gradient(#303030, #252525 20%, #252525 80%, #303030);
}

.dayBorder {
  border-right: 2px solid;
  border-left: 2px solid;
  border-image: linear-gradient(
    to top,
    #303030,
    #707070 30%,
    #707070 70%,
    #303030
  );
  border-image-slice: 1;
}
.btn--large {
  font-size: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Lights.vue